<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- Name or Number -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Name or Number</mat-label>
      <input formControlName="nameOrNumber" matInput placeholder="Name or Number" type="text">
      <mat-error *ngIf="inputForm.controls['nameOrNumber'].hasError('required')">
        Name or Number is required!
      </mat-error>
      <mat-error *ngIf="inputForm.controls['nameOrNumber'].hasError('pattern')">
        Name or Number can't contain any of the following characters : \ / : * ? " < > |
      </mat-error>
    </mat-form-field>
  </div>

</form>
